import { useInfiniteQuery } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

export const useComments = (postId = null, limit = 10, dateFilter = null) => {
  return useInfiniteQuery({
    queryKey: ['comments', postId, dateFilter],
    queryFn: async ({ pageParam = 1 }) => {
      const endpoint = postId 
        ? `/posts/comments?postId=${postId}`
        : '/posts/comments';
        
      const params = { 
        page: pageParam, 
        limit, 
        status: 'all'
      };

      // Add date parameters if they exist
      if (dateFilter?.fromDate) {
        params.fromDate = dateFilter.fromDate;
      }
      if (dateFilter?.toDate) {
        params.toDate = dateFilter.toDate;
      }
        
      const response = await apiClient.get(endpoint, { params });
      
      if (!response.data?.success || !Array.isArray(response.data?.data)) {
        throw new Error('Invalid data format received');
      }
      
      const allComments = response.data.data;
      const statusOrder = { pending: 0, approved: 1, rejected: 2 };
      const sortedComments = [...allComments].sort(
        (a, b) => (statusOrder[a.status] ?? 99) - (statusOrder[b.status] ?? 99)
      );
      
      return {
        items: sortedComments,
        currentPage: pageParam,
        totalPages: Math.ceil(response.data.data.length / limit)
      };
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.currentPage < lastPage.totalPages) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000, // Data is considered fresh for 5 minutes
    cacheTime: 30 * 60 * 1000, // Cache is kept for 30 minutes
  });
}; 